import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Close({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.0022 13.4163L17.295 18.7092L18.7093 17.295L13.4164 12.0021L18.7093 6.70923L17.295 5.29501L12.0022 10.5879L6.70926 5.29501L5.29504 6.70923L10.5879 12.0021L5.29504 17.295L6.70926 18.7092L12.0022 13.4163Z"
        fill={iconColor}
      />
    </Svg>
  );
}
